/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link as CarbonLink } from 'carbon';
import { propsUtils } from '@ba-ui-toolkit/utils';

const { BaPropTypes } = propsUtils;
export default class Link extends Component {
	static propTypes = {
		href: PropTypes.string,
		children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
		hover: BaPropTypes.deprecated('is ignored and not applicable to carbon link'),
		active: BaPropTypes.deprecated('is ignored and not applicable to carbon link'),
		onClick: PropTypes.func,
		className: PropTypes.string,
		style: PropTypes.object,
		small: BaPropTypes.deprecated('is ignored and not applicable to carbon link'),
		shouldForceTabIndex: BaPropTypes.deprecated('is ignored and not applicable to carbon link'),
		disabled: PropTypes.bool,
		tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	};

	static defaultProps = {
		className: '',
		style: {},
		tabIndex: -1,
		disabled: false,
	};

	_interactive = () => {
		const { href, onClick, tabIndex, disabled } = this.props;

		return (href != null || onClick || tabIndex > -1) && !disabled;
	};

	render() {
		const {
			href,
			children,
			onClick,
			className,
			style,
			tabIndex,
			disabled,
			...others
		} = this.props;

		const cProps = {
			href: href || '#', // Temporarily defaulting herf to '#' because no href changes the color to a disabled.
			className,
			style,
			disabled,
			onClick: disabled ? () => false : onClick,
		};

		if (tabIndex > -1) {
			cProps.tabIndex = tabIndex;
		} else {
			cProps.tabIndex = this._interactive() ? 0 : -1;
		}

		return (
			<CarbonLink {...others} {...cProps}>
				{children}
			</CarbonLink>
		);
	}
}
